var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lck-markdown',{attrs:{"settings":_vm.textToDisplayed}})}
var staticRenderFns = []

export { render, staticRenderFns }